import React from "react";

export interface InstagramMedia {
  id: string;
  caption?: string;
  media_type: "IMAGE" | "VIDEO" | "CAROUSEL_ALBUM";
  media_product_type?: string;
  media_url: string;
  thumbnail_url?: string;
  permalink: string;
}

interface IInstagramFeedProps {
  counter: number;
}

interface IInstagramFeedState {
  media: InstagramMedia[];
  hasError: boolean;
  isLoading: boolean;
  isLoadingMore: boolean;
  next: string | null;
}

export class InstagramFeed extends React.Component<
  IInstagramFeedProps,
  IInstagramFeedState
> {
  public state: IInstagramFeedState = {
    media: [],
    hasError: false,
    isLoading: true,
    isLoadingMore: false,
    next: null,
  };

  public componentDidMount() {
    this.loadPage();
  }

  private loadPage = (after?: string) => {
    const query = new URLSearchParams({ limit: String(this.props.counter) });
    if (after) query.set("after", after);

    fetch(`/.netlify/functions/instagram-feed?${query.toString()}`)
      .then((response) => {
        if (!response.ok) throw new Error("Instagram feed request failed");
        return response.json();
      })
      .then((payload) => this.setState((state) => ({
        media: after ? [...state.media, ...(payload.data ?? [])] : payload.data ?? [],
        next: payload.next ?? null,
        isLoading: false,
        isLoadingMore: false,
      })))
      .catch(() => this.setState({
        hasError: true,
        isLoading: false,
        isLoadingMore: false,
      }));
  };

  private loadMore = () => {
    if (!this.state.next || this.state.isLoadingMore) return;
    this.setState({ isLoadingMore: true }, () => this.loadPage(this.state.next!));
  };

  public render() {
    const { hasError, isLoading, isLoadingMore, media, next } = this.state;

    if (isLoading) return <p className="instagram-feed-unavailable">Loading latest posts…</p>;
    if (hasError || media.length === 0) {
      return <p className="instagram-feed-unavailable">Latest posts are available on Instagram.</p>;
    }

    return (
      <>
        <div className="instagram-media-grid">
          {media.map((item) => {
          const isVideo = item.media_type === "VIDEO";
          const isReel = item.media_product_type === "REELS";
          const imageSource = item.thumbnail_url || item.media_url;
          const label = item.caption || (isReel ? "Instagram Reel" : "Instagram post");

          return (
            <a
              className="instagram-media-card"
              href={item.permalink}
              key={item.id}
              target="_blank"
              rel="noreferrer"
              aria-label={`Open ${label} on Instagram`}
            >
              <img src={imageSource} alt="" loading="lazy" />
              {(isVideo || isReel) && <span className="instagram-media-type">Reel</span>}
            </a>
          );
          })}
        </div>
        {next && (
          <button className="instagram-show-more" type="button" onClick={this.loadMore} disabled={isLoadingMore}>
            {isLoadingMore ? "Loading…" : "Show more"}
          </button>
        )}
      </>
    );
  }
}
